import { Component, OnInit, Input, Output } from '@angular/core';
import { OkAloneService } from 'src/app/ok-alone.service';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-awards-main',
  templateUrl: './awards-main.component.html',
  styleUrls: ['./awards-main.component.scss']
})
export class AwardsMainComponent implements OnInit {

  awards: any;
  months: any;
  month:any = null;
  page = "home";
  monitor_subscribed:any = null;
  award_subscribed:any = null;
  
  formGroup = new FormGroup({
    month: new FormControl(this.month,[])
  })
  constructor(public okService: OkAloneService,private router: Router) { 
    
    this.getSetup();
  }

  ngOnInit(): void {

  }

  getSetup(){

    this.okService.get("awards/setup",{month:this.month})
    .subscribe((data:any) => {

      //console.log(data.body);

      data.body['show_demo'] =false;
      this.months = data.body['months'];

      if(data.body['show_demo'] || this.months.length == 0){
        //console.log("Show Awards Demo");
        this.router.navigateByUrl("awards/awards-demo");
      }else{
        this.months = data.body['months'];
        this.monitor_subscribed = data.body['monitor_subscribed'];
        this.award_subscribed = data.body['award_subscribed'];
        this.month = data.body['last_month'];
      }

      //console.log(this.months,this.month);

    });

  }

    
  monthChanged(){
    this.month = this.formGroup.get('month')?.value;
    //console.log("Month",this.month);
  }

  toggleMonitorSubscribe(subscribe:boolean){

    this.okService.put("awards/setup",{monitor_subscribe:subscribe})
    .subscribe((data:any) => {

      this.monitor_subscribed = subscribe;

    });
  }

  toggleWorkerSubscribe(subscribe:boolean){

    this.okService.put("awards/setup",{award_subscribed:subscribe})
    .subscribe((data:any) => {

      this.award_subscribed = subscribe;

    });
  }


}
